import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import FinanceLogin from './FinanceLogin';
import FinanceDashboard from './FinanceDashboard';
import { getFinanceToken } from './api';
import './finance.css';
import './finance-visual.css';

function ProtectedRoute({ children }) {
  const token = getFinanceToken();
  if (!token) {
    return <Navigate to="/finance/login" replace />;
  }
  return children;
}

export default function FinanceApp() {
  return (
    <div className="finance-app">
      <Routes>
        <Route path="/login" element={<FinanceLogin />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <FinanceDashboard />
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<Navigate to="/finance/login" replace />} />
      </Routes>
    </div>
  );
}
